<template>
  <div>
    <SectionHeader :title="$t('orders.headline')">
      <template v-slot:meta>
        <button @click="createBillingExport" class="button button-green button-small button-round">
          {{ $t('orders.createBillingReport') }}
        </button>
        <button @click="createCsvExport" class="button button-green button-small button-round">
          {{ $t('orders.exportOrders') }}
        </button>
        <Link to="/orders/new" class="button button-green button-small button-round">
          {{ $t('orders.new') }}
        </Link>
        <Link
          v-if="companyUser.company.settings && companyUser.company.settings.enable_order_templates"
          to="/order_templates"
          class="button button-green button-small button-round"
        >
          {{ $t('meta.orderTemplates') }}
        </Link>
      </template>
    </SectionHeader>

    <OrdersFilters v-model="filter" />

    <OrdersTable :companyUuid="companyUser.company_uuid" v-model="filter" />
  </div>
</template>

<script>
import OrdersFilters from '@/components/Orders/OrdersFilters/index.vue'
import OrdersTable from '@/components/Orders/OrdersTable/index.vue'
import SectionHeader from '@/components/SectionHeader/index.vue'

import exportsApi from '@/api/exports'

export default {
  name: 'OrdersView',
  components: { OrdersTable, OrdersFilters, SectionHeader },
  inject: ['companyUser'],
  data: () => ({
    filter: {},
  }),
  methods: {
    async createBillingExport() {
      await exportsApi.create({
        type: 'waste_stream_export',
        company_uuid: this.companyUser.company_uuid,
      })
    },
    async createCsvExport() {
      await exportsApi.create({
        type: 'orders_actions_csv',
        company_uuid: this.companyUser.company_uuid,
        status: this.filter.status === 'all' ? null : this.filter.status,
        from: this.filter.from,
        to: this.filter.to,
      })
    },
  },
}
</script>
